<template>
  <div class="animate_animated animate__slideInRight">
    <div class="fixed inset-x-0 top-0 z-20">
      <div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80 ">
         <div class="h-1 bg-gradient-to-r from-[#00cdac] to-[#62EC14]"></div>
        <div class="flex items-center px-4 py-4">
          <div class="w-1/2">
            <div class="flex items-center w-full">
              <a @click="$router.push('/')"><img src="@/assets/back-arrow.svg" alt=""></a>
              <span class="text-base text-content font-medium ml-4">{{ 'Projects' }}</span>
            </div>
          </div>
          <div class="w-1/2">
            <div class="flex items-center justify-end">
              <a @click="share = true" class="mr-2 relative text-main bg-slate-100 p-2.5 rounded-xl "><Share  class="size-5"/>
                <div v-if="shareSelectedProperty.length > 0"
                  class="absolute w-4 h-4 -right-1 -top-1 bg-black text-white rounded-full items-center flex justify-center font-medium">
                  <span class=" text-xxs block ">{{ shareSelectedProperty.length }}</span></div>
              </a>
              <a @click="$router.push('searchproject')" class=" text-main bg-slate-100 p-2.5 rounded-xl"><Filter class="size-5"/></a>
            </div>
          </div>
        </div>
        <div class="flex px-3 pb-3">
          <div class="flex items-strech w-full gap-2">
            <div class="relative w-full">
              <input type="text" @input="e => bsTerm = e.target.value" :value="bsTerm" name="" id=""
                placeholder="Search Projects"
                class="border border-inputBorder round-md p-3 w-full z-auto focus:outline-none rounded-xl">
              <button type="button" class="absolute right-0 top-0 m-3" v-if="bsTerm" @click="resetBs">
                <img src="@/assets/close-icon.svg" alt="" class="transform rotate-45"></button>
            </div>

            <div class="bg-primary px-4 flex items-center rounded-xl">
              <button type="button" :disabled="!bsTerm" @click="performBs">
                <img src="@/assets/search-icon-white.svg" alt="" class=""></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card-List -->
    <div class="pt-16 mt-18 bg-gray-50 min-h-screen px-4">
      <span class="result-Text p-3 text-sm text-main text-opacity-50 block">Showing {{ pageStart }} - {{ pageEnd
      }} of {{ total }}</span>
      <ImageViewer :visible="visible" :imgs="imgList" @hide="handleHide" />
      
      <div class=" bg-white py-3 my-3 rounded-xl" v-for="(pl, key) in projectList" :key="key">
        <div class="flex items-center gap-4 px-3">
          <div class="max-w-32 w-full">
            <div class="flex">
              
              <div class="w-full relative ">
                <div class="absolute bottom-1 w-full px-1 pointer-events-none text-center" v-if="pl.possession_status">
                  <span class="flex items-center justify-center w-full max-w-[100px] mx-auto px-1 text-[9px] font-medium  py-1 rounded-lg mb-2 " style="line-height: 1;"
                    :class="statusPillClass(pl.possession_status)">{{ pl.possession_status }}</span>
                </div>
                  
                <img :src="pl.image_url.length > 0 ? pl.image_url : 'https://engage-prod.s3.ap-south-1.amazonaws.com/images/app/engage-app-prod.jpeg'" @click="opeLightBox(pl.image_url)" alt=""
                  class="rounded-lg  w-full h-20 object-cover object-center border-none ">
                 
              </div>
            </div>
          </div>
          <div class="w-full">
            <router-link :to="{ name: 'ProjectDetails', params: { uuid: pl.uuid } }">
              <div class="">
                <div class="flex items-center mb-1">
                  
                    <span v-if="created_user" class="text-xs text-black font-medium ml-2 text-opacity-50">{{pl.user_name}}</span>
                </div>
               
                <h2 class="text-content text-sm font-medium mb-1 capitalize">{{ pl.name }}</h2>
                <div class="flex items-center"><span
                    class="text-main text-xs ">{{ pl.locality }}, {{ pl.city }}</span>
                </div>
                
              </div>
            </router-link>
            
          </div>
          <div class="ml-auto flex items-center">
             <input
    type="checkbox"
    v-model="shareSelectedProperty"
    :value="pl"
    class="sr-only"
    :id="'share-' + key"
  />

  <label
    :for="'share-' + key"
    :class="[
      'inline-flex items-center gap-1 px-2 py-1 rounded font-medium text-xs cursor-pointer transition',
      shareSelectedProperty.includes(pl)
        ? 'bg-black text-white shadow'
        : 'bg-slate-100 text-main hover:bg-slate-200'
    ]"
    tabindex="0"
  >
    <Share class="size-4" />
    <span>Share</span>
  </label>
          </div>
        </div>
      </div>
    
      <router-link :to="{ name: 'NewProject' }" v-if="!$route.query.match"
        class="fixed bottom-6 right-6 z-50 overflow-hidden group rounded-xl px-4 py-4 flex items-center gap-2 text-white shadow-xl ring-1 ring-white/10 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-500 hover:from-emerald-500 hover:to-teal-500 transition-all duration-300 ease-out hover:scale-105 active:scale-95 shine">
        <img src="@/assets/plus-icon.svg" alt="">
      </router-link>
      <div class="pagination-holder">
        <Pagination v-if="totalPages > 1" v-model="pageNo" :total-pages="totalPages" @update:modelValue="goToPage" />
      </div>
      <Modal v-model="share" header="Share Project">
        <div class="flex flex-col ">
          <button
            class="flex items-center gap-3 px-4 py-3 rounded-lg bg-gradient-to-r from-[#00cdac]/10 to-[#62EC14]/10 hover:from-[#00cdac]/20 hover:to-[#62EC14]/20 transition text-main font-medium mb-4"
            @click="shareWhatsApp()">
            <WhatsApp class="size-8 text-[#00cdac]" />
            <span class="text-base">Share via WhatsApp</span>
          </button>
      
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
import ImageViewer from '@/components/Common/ImageViewer.vue'
import Modal from '@/components/Common/Modal.vue'
import { paramsFromQuery, numDifferentiation, prepareProjectSearchParams } from '@/assets/scripts/utility.js';
import Share from '@/components/icons/Share.vue';
import Filter from '@/components/icons/Filter.vue';
import WhatsApp from '@/components/icons/WhatsApp.vue';
export default {
  components: {
    Modal,
    ImageViewer,
    Share,
    Filter,
    WhatsApp
  },
  name: 'Projects',
  data() {
    return {
      bsTerm: this.$route.query.bs,
      shareSelectedProperty: [],
      total: 0,
      perPage: 0,
      projectList: [],
      advSearchParams: [],
      imgList: [],
      index: 0,
      share: false,
      shareMailLink: '',
      visible: false,
    }
  },
  watch: {
    $route(to, from) {
      this.loadProjects();
    }
  },
  created() {
    this.loadProjects()
  },
  methods: {
    priceinLacs(value) {
      return numDifferentiation(value)
    },
    opeLightBox(img_url) {
      this.imgList = img_url
      this.index = 1
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    shareWhatsApp() {
      let link = 'https://api.whatsapp.com/send?text='
      let url = ''
      this.shareSelectedProperty.forEach(proj_detail => {
        url = url + `%F0%9F%8F%A8+Project+Details%0D%0A%F0%9F%91%89+Project+Name+%3A+${proj_detail.name}${proj_detail.possession_status ? '%0D%0A%F0%9F%91%89+Possession+On+%3A+' + proj_detail.possession_status : ''}${proj_detail.formatted_possession_date ? '%0D%0A%F0%9F%91%89+Possession+Date+%3A+' + proj_detail.formatted_possession_date : ''}${proj_detail.property_age ? '%0D%0A%F0%9F%91%89+Property+Age+%3A+' + proj_detail.property_age + '+Years' : ''}${proj_detail.rera_no ? '+%0D%0A%F0%9F%91%89+Rera+No%3A+' + proj_detail.rera_no : ''}${proj_detail.project_approve_by ? '%0D%0A%F0%9F%91%89+Project+Approved+by%3A+' + proj_detail.project_approve_by : ''}${proj_detail.location ? '%0D%0A%F0%9F%91%89+Project+Location%3A+' + proj_detail.location : ''}${proj_detail.city ? '%0D%0A%F0%9F%91%89+City+%3A+' + proj_detail.city : ''}${proj_detail.locality ? '%28East%29%2C+' + proj_detail.locality : ''}%0D%0A%0D%0A%F0%9F%8C%8D+++https%3A%2F%2Fwww.google.com%2Fmaps%2Fsearch%2F%3Fapi%3D1%26query%3D${proj_detail.lat}%2C${proj_detail.long}%0D%0A%0D%0A`
      })
      link = link + url
      window.open(link)
    },
    loadProjects() {
      let queryP = {}
      if (Object.keys(this.advSParams).length > 0) {
        queryP["as"] = true
        let searchParams = prepareProjectSearchParams(this.advSParams);
        for (let key in searchParams) {
          queryP[key] = searchParams[key];
        }
        this.advSearchParams = queryP
      }
      if (this.advSearchParams.length > 0) {
        paramsFromQuery(queryP, this.advSearchParams, status);
      }
      else {
        paramsFromQuery(queryP, this.$route.query, status);
      }
      let data = this.$axios.get('/mobile_crm/projects', {
        params: queryP,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
      })
        .then(res => {
          this.projectList = res.data.projects;
          this.perPage = res.data.per_page;
          this.total = res.data.count;
        })
        .catch(err => console.log(err));
    },
    goToPage(pageNo) {
      let newQ = { ...this.$route.query, pageNo };
      this.$router.replace({ query: newQ });
    },
    resetBs() {
      let rQ = this.$route.query
      this.bsTerm = ''
      if (rQ.bs) {
        delete rQ.bs;
        let reset = {}
        for (let key in rQ) {
          reset[key] = rQ[key];
        }
        reset['reset'] = reset.reset ? (reset.reset == 0 ? 1 : 0) : 1
        this.$router.replace({ query: reset })
      }
    },
    performBs() {
      if (this.bsTerm) {
        let newQ = { ...this.$route.query, bs: this.bsTerm }
        delete newQ.pageNo
        this.$router.replace({ query: newQ })
      }
    },
      statusPillClass(status) {
    if (!status) return 'bg-slate-100 text-slate-600';
    const s = status.toLowerCase();
    if (s.includes('ready')) return 'bg-emerald-50 text-emerald-600';
    if (s.includes('under') || s.includes('construction')) return 'bg-amber-50 text-amber-600';
    if (s.includes('new') || s.includes('launch')) return 'bg-sky-50 text-sky-600';
    return 'bg-slate-100 text-slate-600';
  },
  },
  computed: {
    userName() {
      return localStorage.getItem('property-user-name')
    },
    userEmail() {
      return localStorage.getItem('property-user-email')
    },
    userMobile() {
      return localStorage.getItem('property-user-mobile')
    },
    created_user(){
      return this.$store.getters.created_user;
    },
    advSParams() {
      return this.$store.getters.advSParams;
    },
    totalPages() {
      if (this.total === 0 || this.perPage === 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.perPage);
      }
    },
    pageNo: {
      get() {
        let pageNo = this.$route.query.pageNo || 1
        return parseInt(pageNo);
      },
      set() {
        true;
      }
    },
    pageStart() {
      if (this.total === 0) {
        return 0;
      }
      return (Math.max(0, (this.pageNo - 1) * this.perPage + 1))
    },
    pageEnd() {
      if (this.total === 0) {
        return 0;
      }
      return (Math.min(this.total, this.pageNo * this.perPage))
    },
  }
}
</script>
